/**
 * Shared slug utilities for SEO landing pages.
 * Converts community/school names to clean URL slugs and back.
 */

import { COMMUNITY_PRICES } from '@/data/communityPrices';
import { SCHOOLS } from '@/data/schools';

/** Convert a display name to a URL slug */
export function toSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[''`]/g, '')          // remove apostrophes
    .replace(/[^a-z0-9\s-]/g, '')  // remove special chars
    .trim()
    .replace(/\s+/g, '-')           // spaces → hyphens
    .replace(/-+/g, '-')            // collapse multiple hyphens
    .replace(/\b(ii)\b/g, '2')      // Roman numeral II → 2
    .replace(/\b(iii)\b/g, '3');    // Roman numeral III → 3
}

/** Find a community by slug */
export function communityBySlug(slug: string) {
  return COMMUNITY_PRICES.find(c => toSlug(c.name) === slug) ?? null;
}

/** Find a school by slug */
export function schoolBySlug(slug: string) {
  return SCHOOLS.find(s => toSlug(s.name) === slug) ?? null;
}

/** All community slugs for generateStaticParams */
export function allCommunitySlugs(): string[] {
  return COMMUNITY_PRICES.map(c => toSlug(c.name));
}

/** All school slugs for generateStaticParams */
export function allSchoolSlugs(): string[] {
  return SCHOOLS.map(s => toSlug(s.name));
}
